/**
 * Model class for help messages
 */

import { required } from 'vuelidate/lib/validators'

export default {
    fields: {
        id: {
            type: Number,
            showIf (model) {
                return false
            },
        },
        tag: {
            label: 'Tag',
            type: 'text',
            validations: {
                required,
                tag_unique: async function (value) {        //  do NOT convert to (value)=> format
                    if (value) {
                        let filters = {
                            tag: { field: 'tag', value: value }
                        }
                        let help_id = this.$v.form['id'] ? this.$v.form['id'].$model : null
                        if (help_id) {
                            filters.id = { field: 'id', value: help_id, negate: true }
                        }
                        return await this.$api.getItems(this, 'help', filters, null, [])
                            .then((helps) => {
                                return helps ? !helps.length : true
                            })
                    }
                    return true
                }
            },
            invalidFeedback: {
                required: 'The help tag is required',
                name_unique: 'This help tag already exists',
            }
        },
        content: {
            label: 'Content',
            type: 'rich'
        },
    },
}
